// Browser-local navigation preferences are isolated from other accounts and tenants.
export const createNavigationStorage = (serverUrl, user, storage) => {
  if (!user.username || user.isPublicAccess) return null;
  const prefix = `dataunfoldNavigation:${JSON.stringify([
    serverUrl || window.location.origin,
    user.username,
    user.organizationId || '',
  ])}:`;
  try {
    const target = storage || window.localStorage;
    return {
      getItem: key => target.getItem(prefix + key),
      setItem: (key, value) => target.setItem(prefix + key, value),
      removeItem: key => target.removeItem(prefix + key),
    };
  } catch (error) {
    return null;
  }
};

export const readNavigationItem = (storage, key) => {
  try {
    return storage?.getItem(key) || '';
  } catch (error) {
    return '';
  }
};

export const writeNavigationItem = (storage, key, value) => {
  try {
    storage?.setItem(key, value);
  } catch (error) {
    // Unavailable browser storage must not prevent opening a project.
  }
};

export const normalizeResumePath = path => (
  /^\/(case|validate)\/[1-9]\d*(?:\?queue=(?:split|normal))?$/.test(path || '') ? path : ''
);
